import { css } from '@emotion/react';
import React from 'react';

type HintProps = {
  children?: React.ReactNode;
  paddingTop?: boolean;
  paddingBottom?: boolean;
};

const Hint: React.FC<HintProps> = ({ children, paddingTop = false, paddingBottom = false }) => {
  return (
    <div
      className="hint"
      css={css`
        padding-top: ${paddingTop ? '1em' : '0'};
        padding-bottom: ${paddingBottom ? '1em' : '0'};
        width: 100%;
        text-align: center;
        font-weight: 600;
        font-size: 13px;
      `}
    >
      {children}
    </div>
  );
};

export default Hint;
